import { Component, type ReactNode } from "react";
import "./admin-panel.css";

type AdminErrorBoundaryProps = {
  children: ReactNode;
};

type AdminErrorBoundaryState = {
  hasError: boolean;
};

export class AdminErrorBoundary extends Component<
  AdminErrorBoundaryProps,
  AdminErrorBoundaryState
> {
  state: AdminErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): AdminErrorBoundaryState {
    return { hasError: true };
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="admin-login">
        <div className="admin-login__card">
          <p className="admin-kicker">Rayk Booking</p>
          <h1>Verwaltung konnte nicht geöffnet werden</h1>
          <p>
            Die sichere Verbindung zur Verwaltung ist gerade nicht verfügbar. Bitte lade die Seite
            neu.
          </p>
          <button className="admin-button" type="button" onClick={() => window.location.reload()}>
            Seite neu laden
          </button>
          <a className="admin-back-link" href="/">
            Zur Buchungsseite
          </a>
        </div>
      </main>
    );
  }
}
